var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"zoom","mode":"out-in"}},[(_vm.time)?_c('div',{staticClass:"countdown"},[_c('loader',{staticClass:"mr-10"}),_vm._v(" "),_c('div',[_c('span',[_vm._v("TEMPO RESTANTE")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.time))])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c6c1cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/Countdown.vue
// module id = null
// module chunks = 